<template>
  <!-- <div> -->
  <VCard class="wrapper" v-if="isDialogType" :color="color" :radius="4">
    <VBlock :direction="Direction.column">
      <VBlock class="contents-wrapper" :direction="Direction.column" :sort="Sort.left_top">
        <VBlock class="header-box" :sort="Sort.left_center">
          <slot name="header"></slot>
        </VBlock>
        <VBlock class="contents-box">
          <slot name="contents"></slot>
        </VBlock>
      </VBlock>
      <VBlock class="button-wrapper">
        <slot name="footer"></slot>
      </VBlock>
    </VBlock>
  </VCard>
  <VCard class="custom-modal" v-else :color="color" :radius="0">
    <VBlock class="custom-modal-inside" :direction="Direction.column">
      <slot></slot>
    </VBlock>
  </VCard>
  <!-- </div> -->
</template>

<script>
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

import VCard from '@/presentationals/v2/components/layouts/molecules/VCard'
import VBlock, { Direction, Sort } from '@/presentationals/v2/components/layouts/molecules/VBlock'

export const ModalType = Object.freeze({
  dialog: 'dialog',
  custom: 'custom'
})

export const ColorType = Object.freeze({
  none: 'transparent',
  brand: 'brand-background',
  brand2: 'brand-background-2',
  gray: 'gray-background',
  white: 'white-background'
})

export default {
  name: 'VModal',
  props: {
    type: {
      type: String,
      default: ModalType.dialog
    },
    color: {
      type: String,
      default: ColorType.white
    },
    isScroll: {
      type: Boolean,
      default: true
    }
  },
  components: {
    VCard,
    VBlock
  },
  computed: {
    isDialogType() {
      return this.type === ModalType.dialog
    }
  },
  mounted() {
    this.targetElement = document.getElementById('modal-layer')
    if (this.isScroll) disableBodyScroll(this.targetElement)
  },
  beforeDestroy() {
    if (this.isScroll) enableBodyScroll(this.targetElement)
  },
  data() {
    return {
      ColorType,
      Direction,
      Sort,

      targetElement: null
    }
  }
}
</script>

<style>
.scroll-off {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100%;
  max-height: 100vh;
  overflow: hidden;
  /* position: fixed; */
}
</style>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.wrapper {
  // max-width: 300px;
  width: 100%;
  height: auto;
}

.contents-wrapper {
  padding: 30px 20px 30px 20px;

  .header-box {
    box-sizing: border-box;
    margin-bottom: 8px;
  }

  .contents-box {
    box-sizing: border-box;
    text-align: center;
  }
}

.button-wrapper {
  border-top: 1px solid $light-gray-5;
  width: 100%;
  height: 50px;

  .cancel-button,
  .ok-button {
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .mid-line {
    width: 2px;
    height: 100%;
    background-color: $light-gray-2;
  }
}

.custom-modal {
  width: 100%;
  height: auto;
  box-sizing: border-box;

  .custom-modal-inside {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  }
  // position: fixed;
  // top: 0;
  // left: 0;
}
</style>